'use client';

// TO DO remove ref since it should be dependon the component that uses it
import type { ConfirmedDialogRef } from '../components';
import { useRef } from 'react';

type UseDialogRefProps = {
	onConfirm: () => Promise<void>;
};

export const useDialogRef = ({ onConfirm }: UseDialogRefProps) => {
	const dialogRef = useRef<ConfirmedDialogRef>(null);

	const handleOnClick = async() => {
		await onConfirm();
		dialogRef.current?.close();
	};

	return {
		dialogRef,
		handleOnClick,
	};
};
